import { Cookies } from "react-cookie";
// import {useSelector} from 'react-redux';

const isUserAuthenticated = () => {
  const token = getAuthToken();

  if (token == null) {
    setToken(null);

    return false;
  }

  return true;
};

// const isUserAuthenticatedRedux = () => {
//   const auth = useSelector((state) => state.auth);
//   if (auth == null) {
//     return false;
//   } else if (auth.user == null) {
//     return false;
//   }
// }

const getAuthToken = () => {
  const cookies = new Cookies();
  const token = cookies.get("token");

  return token;
};

const getIsUserKeepLogin = () => {
  const cookies = new Cookies();
  const refresh = cookies.get("refresh");

  return refresh;
};

const setToken = (token) => {
  let cookies = new Cookies();
  if (token != null) cookies.set("token", token, { path: "/" });
  else {
    cookies.set("token", null, {path: "/"})
    cookies.remove("token", { path: "/" })
    
  };
};

const setIsRefresh = (isRefresh) => {
  let cookies = new Cookies();
  if (isRefresh) cookies.set("refresh", isRefresh, { path: "/" });
  else cookies.remove("token", { path: "/" });
};

export {
  isUserAuthenticated,
  getAuthToken,
  setToken,
  getIsUserKeepLogin,
  setIsRefresh,
};
